<template>
  <div class="couponlist">
    <van-coupon-cell
    :coupons="coupons"
    :chosen-coupon="chosenCoupon"
    @click="showList = true"
    />
    <!-- 优惠券列表 -->
    <van-popup
    v-model="showList"
    round
    position="bottom"
    style="height: 90%; padding-top: 4px;"
    >
    <van-coupon-list
        :coupons="coupons"
        :chosen-coupon="chosenCoupon"
        :disabled-coupons="disabledCoupons"
        @change="onChange"
        @exchange="onExchange"
    />
    </van-popup>
  </div>

</template>
<script>
import Vue from "vue";
import { CouponCell, CouponList } from 'vant';


Vue.use(CouponCell);
Vue.use(CouponList);

const coupon = {
  available: 1,
  condition: '无使用门槛\n最多优惠12元',
  reason: '',
  value: 150,
  name: '优惠券',
  startAt: 1653978198,
  endAt: 1656656598,
  valueDesc: '1.5',
  unitDesc: '元',
};

export default {
  name: "coupon",
  data() {
    return {
      chosenCoupon: -1,
      coupons: [coupon],
      disabledCoupons: [coupon],
    };
  },
  methods: {
    onChange(index) {
      this.showList = false;
      this.chosenCoupon = index;
    },
    onExchange() {
      this.coupons.push(coupon);
    },
  },
};
</script>


<style lang="scss" scoped>

</style>
